module.exports = __webpack_public_path__ + "static/media/fundoLogin.a16e608c.jpg";